import "core-js/modules/es.array.map";
import "core-js/modules/es.string.link";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { useDispatch } from 'react-redux';
import AccessibleClick from 'wfui-digital-core/es/AccessibleClick';
import Markup from 'wfui-digital-core/es/Markup';
import Block from 'wfui-digital-core/es/Block';
import navigate from '../../../lib/navigation/navigate';
import styles from './Links.less';

var Link = function Link(_ref) {
  var link = _ref.link;
  var dispatch = useDispatch();

  var onClick = function onClick() {
    return navigate({
      dispatch: dispatch,
      link: link
    });
  };

  return /*#__PURE__*/React.createElement(Block, {
    el: "li"
  }, /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement("a", {
    role: "link",
    tabIndex: "0",
    onAccessibleClick: onClick
  }, /*#__PURE__*/React.createElement(Markup, {
    content: link.label
  }))));
};

var Links = function Links(_ref2) {
  var links = _ref2.links;
  return /*#__PURE__*/React.createElement(Block, {
    el: "ul",
    className: styles.links
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(Link, {
      key: index,
      link: link
    });
  }));
};

export default Links;